export default __webpack_public_path__ + "static/media/PGL_Login_logo.019391b7.png";